/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Complete line item information
 * @export
 * @interface LineItemDetail
 */
export interface LineItemDetail {
    /**
     * Database primary key for the line item
     * @type {number}
     * @memberof LineItemDetail
     */
    lineItemId: number;
    /**
     * ID of the parent estimate
     * @type {number}
     * @memberof LineItemDetail
     */
    estimateId: number;
    /**
     * ID of the associated room
     * @type {number}
     * @memberof LineItemDetail
     */
    roomId: number | null;
    /**
     * Line item description
     * @type {string}
     * @memberof LineItemDetail
     */
    description: string;
    /**
     * Line item number extracted from PDF (may be null)
     * @type {string}
     * @memberof LineItemDetail
     */
    lineItemNumber?: string | null;
    /**
     * Quantity
     * @type {number}
     * @memberof LineItemDetail
     */
    qty: number;
    /**
     * Unit of measure (e.g., "SQFT", "EA", "LF")
     * @type {string}
     * @memberof LineItemDetail
     */
    uom: string;
    /**
     * Unit price in cents
     * @type {number}
     * @memberof LineItemDetail
     */
    unitPriceCents: number;
    /**
     * Depreciation amount in cents
     * @type {number}
     * @memberof LineItemDetail
     */
    depreciationCents?: number;
    /**
     * Whether the item is taxable
     * @type {boolean}
     * @memberof LineItemDetail
     */
    taxable?: boolean;
    /**
     * Total line amount in cents
     * @type {number}
     * @memberof LineItemDetail
     */
    rcvCents: number;
    /**
     * When the line item was created
     * @type {Date}
     * @memberof LineItemDetail
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the LineItemDetail interface.
 */
export function instanceOfLineItemDetail(value: object): value is LineItemDetail {
    if (!('lineItemId' in value) || value['lineItemId'] === undefined) return false;
    if (!('estimateId' in value) || value['estimateId'] === undefined) return false;
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('qty' in value) || value['qty'] === undefined) return false;
    if (!('uom' in value) || value['uom'] === undefined) return false;
    if (!('unitPriceCents' in value) || value['unitPriceCents'] === undefined) return false;
    if (!('rcvCents' in value) || value['rcvCents'] === undefined) return false;
    return true;
}

export function LineItemDetailFromJSON(json: any): LineItemDetail {
    return LineItemDetailFromJSONTyped(json, false);
}

export function LineItemDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItemId': json['lineItemId'],
        'estimateId': json['estimateId'],
        'roomId': json['roomId'],
        'description': json['description'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
        'qty': json['qty'],
        'uom': json['uom'],
        'unitPriceCents': json['unitPriceCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'taxable': json['taxable'] == null ? undefined : json['taxable'],
        'rcvCents': json['rcvCents'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function LineItemDetailToJSON(json: any): LineItemDetail {
    return LineItemDetailToJSONTyped(json, false);
}

export function LineItemDetailToJSONTyped(value?: LineItemDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItemId': value['lineItemId'],
        'estimateId': value['estimateId'],
        'roomId': value['roomId'],
        'description': value['description'],
        'lineItemNumber': value['lineItemNumber'],
        'qty': value['qty'],
        'uom': value['uom'],
        'unitPriceCents': value['unitPriceCents'],
        'depreciationCents': value['depreciationCents'],
        'taxable': value['taxable'],
        'rcvCents': value['rcvCents'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

